// extracted by mini-css-extract-plugin
export default {"modalContainer":"ServiceCancelationModal_modalContainer__WRjhF","cancelInfo":"ServiceCancelationModal_cancelInfo__4XAXH"};